export const ASSET_TYPE = 'assetType';
export const CONTENT_BANK_ASSET_TYPE = 'contentBankAssetType';
export const CARDS_ASSET_TYPE = 'cardsAssetType';
export const STORY_ID = 'storyId';
export const STUDIO_STORY_ID = 'studioStoryId';
export const RESOURCE_ID = 'resourceId';
export const STUDIO_DEFINITION_ID = 'studioDefinitionId';
export const CMS_PAGE_ID = 'cmsPageId';
export const ADD_NEW_PAGE = 'addNewPage';
export const IS_NEW = 'isNew';
export const MEDIA_LIBRARY_ASSETS = 'mediaLibraryAssets';

export const AssetTypes = {
  Story: 'story',
  StoryThumbnail: 'storyThumbnail',
  StoryAnimatedThumbnail: 'storyAnimatedThumbnail',
  StoryCircularAnimatedThumbnail: 'storyCircularAnimatedThumbnail',
  StoryIcon: 'storyIcon',
  Landscape: 'landscape',
  Clip: 'clip',
  ClipThumbnail: 'clipThumbnail',
  ClipAnimatedThumbnail: 'clipAnimatedThumbnail',
  ContentBankAsset: 'contentBankAsset',
  CardsAsset: 'cardAsset',
  Portrait: 'portrait',
  Print: 'print',
  Vertical: 'vertical',
  Square: 'square',
  ThreeFour: 'threeFour',
  Ad: 'ad',
  Wide: 'wide',
  Template: 'template',
};

export const isAnimatedThumbnailAssetType = (assetType) =>
  assetType === AssetTypes.StoryAnimatedThumbnail ||
  assetType === AssetTypes.StoryCircularAnimatedThumbnail ||
  assetType === AssetTypes.ClipAnimatedThumbnail;

export const getAnimatedThumbnailResource = (assetType) => {
  if (
    assetType === AssetTypes.StoryAnimatedThumbnail ||
    assetType === AssetTypes.StoryCircularAnimatedThumbnail
  ) {
    return 'stories';
  }

  if (assetType === AssetTypes.ClipAnimatedThumbnail) {
    return 'clips';
  }

  return null;
};

export const getAssetRatio = (assetType) => {
  switch (assetType) {
    case AssetTypes.Vertical:
    case AssetTypes.Story:
    case AssetTypes.Clip:
    case AssetTypes.Ad:
      return 9 / 16;
    case AssetTypes.Landscape:
      return 16 / 9;
    case AssetTypes.Portrait:
      return 4 / 5;
    case AssetTypes.Print:
    case AssetTypes.StoryThumbnail:
    case AssetTypes.ClipThumbnail:
    case AssetTypes.StoryAnimatedThumbnail:
    case AssetTypes.ClipAnimatedThumbnail:
      return 2 / 3;
    case AssetTypes.ThreeFour:
      return 3 / 4;
    case AssetTypes.Square:
    case AssetTypes.StoryIcon:
    case AssetTypes.StoryCircularAnimatedThumbnail:
    case AssetTypes.CardsAsset:
      return 1;
    case 'facebookHeader':
      return 2.3;
    case 'xHeader':
      return 3;
    case 'youTubeHeader':
      return 16 / 9;
    case AssetTypes.Wide:
      return 4 / 1;
    default:
      return 0;
  }
};
